// @ts-nocheck
import {
    BecomeADistributorModel,
    BecomeADistributorRequestApiParameter,
} from "@store/Framework/Store/Bunzl/Components/BecomeADistributorForm/BecomeADistributorFormTypes";
import isApiError from "@insite/client-framework/Common/isApiError";
import { post, ServiceResult } from "@insite/client-framework/Services/ApiService";

const becomeADistributorUrl = "api/v1/custom/Distributor/Request";

export async function sendBecomeADistributor(
    parameter: BecomeADistributorRequestApiParameter,
): Promise<ServiceResult<BecomeADistributorModel>> {
    try {
        const becomeADistributor = await post<BecomeADistributorModel>(
            `${becomeADistributorUrl}`,
            parameter.fields as BecomeADistributorModel,
        );
        return {
            result: becomeADistributor,
            successful: true,
        };
    } catch (error) {
        if (isApiError(error) && "status" in error) {
            if (error.status === 404) {
                return {
                    successful: false,
                    errorMessage: "An error occured",
                };
            }

            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}
